import { Button, buttonClass } from "@unizpay/ui";
import { Plus } from "lucide-react";
import { Link } from "react-router";
import { usePermission } from "../lib/profile";

/**
 * Primary "Create payment link" action, opening the create page: hidden for roles that cannot
 * create payments, disabled until payouts are set up.
 */
export function CreatePaymentLinkButton({ settlementReady }: { settlementReady: boolean }) {
  const allowed = usePermission("payments.write");
  if (!allowed) return null;
  const label = (
    <>
      <Plus aria-hidden="true" className="size-4" />
      Create payment link
    </>
  );
  return settlementReady ? (
    <Link to="/payments/new" className={buttonClass("primary")}>
      {label}
    </Link>
  ) : (
    <Button disabled title="Set up payouts first">
      {label}
    </Button>
  );
}
